var defaultUser = {
    Etag: "",
    uuid: "",
    dob: "",
    email: "",
    firstname: "",
    lastname: "",
    gender: "",
    phone: "",
    profile_img: "",
    roles: [],
    settings: {},
    source: "",
    teams: [],
    teamIds: [],
    tenant: "",
    createdAt: ""
};
export default defaultUser;
